// TODO: setup navigation to position detail page `/admin/positions/id`
export const SpeculatorDetailOrdersComponent = () => {
  return (
    <>
      {/* <StatsRowComponent stats={stats} /> */}
      {/* <DataTable {...dataTableConfig} /> */}
      <h1>Speculator Orders??</h1>
    </>
  );
};
